import { projectClubwiseCsv, type ClubwiseFileKind, type ClubwiseJoinRow, type ClubwiseLeadRow } from './csv.js';

// The browser's file-slot logic, kept PURE (text in, verdict out) so the
// "wrong file in a slot" rule is tested without a DOM.

export const SLOT_LABEL: Record<ClubwiseFileKind, string> = {
  leads: 'New Prospects',
  joins: 'Joiners',
};

export type SlotResult =
  | { ok: true; kind: 'leads'; rows: ClubwiseLeadRow[]; skippedBlank: number }
  | { ok: true; kind: 'joins'; rows: ClubwiseJoinRow[]; skippedBlank: number }
  | { ok: false; error: string };

/**
 * Read a file's decoded text for a given SLOT.
 *
 * ⚠️ The file's kind is detected from its HEADERS, and a mismatch with the slot
 * is refused by name ("this looks like the Joiners file"): a Joiners file in the
 * New Prospects slot would otherwise be read as a lead list with no joining
 * dates, and the month's leads would silently be the joiners.
 */
export function readSlotFile(slot: ClubwiseFileKind, text: string): SlotResult {
  const projected = projectClubwiseCsv(text);
  if (!projected.ok) return projected;
  if (projected.kind !== slot) {
    return {
      ok: false,
      error: `This looks like the ${SLOT_LABEL[projected.kind]} file, not ${SLOT_LABEL[slot]}. Put it in the ${SLOT_LABEL[projected.kind]} slot.`,
    };
  }
  return projected;
}

/** Decode a ClubWise export. latin-1 (windows-1252), NOT utf-8. */
export function decodeClubwiseBytes(buffer: ArrayBuffer): string {
  return new TextDecoder('windows-1252').decode(buffer);
}
